angular.module('app')
  .factory('$localStorage', function ($window) {
    return {
      set: (key, value) => {
        $window.localStorage[key] = value;
      },

      get: (key, defaultValue) => $window.localStorage[key] || defaultValue,

      setObject: (key, value) => {
        $window.localStorage[key] = JSON.stringify(value);
      },

      getObject: (key) => {
        try {
          return JSON.parse($window.localStorage[key]);
        } catch (error) {
          return null;
        }
      },

      getObjectProperty: (key, property) => {
        try {
          return JSON.parse($window.localStorage[key])[property];
        } catch (error) {
          return undefined;
        }
      },

      isSet: key => typeof $window.localStorage[key] !== 'undefined',

      unset: (key) => {
        delete $window.localStorage[key];
      },
    };
  });
